// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomRangeSlider_wrapper__GBwuM {
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.CustomRangeSlider_sliderTrack__h1XCR {
  position: relative;
  height: 30px;
  background: #dcdcdc;
  border-radius: 6px;
  margin-bottom: 8px;
}

/* зелёная заливка */
.CustomRangeSlider_sliderTrack__h1XCR {
  position: relative;
  height: 6px;
  background: #e0e0e0;
  border-radius: 3px;
  margin-bottom: 8px;
}

/* Зелёная активная часть */
.CustomRangeSlider_sliderTrack__h1XCR::before {
  content: '';
  position: absolute;
  height: 6px;
  background-color: #2e7d32;
  border-radius: 3px;
  top: 0;
  left: var(--minPos);
  width: calc(var(--maxPos) - var(--minPos));
  z-index: 1;
}

.CustomRangeSlider_thumb__Z0e5T {
  pointer-events: none;
  position: absolute;
  top: -12px;
  height: 30px;
  width: 100%;
  background: none;
  appearance: none;
  margin: 0;
  z-index: 2;
}

.CustomRangeSlider_thumb__Z0e5T::-webkit-slider-thumb {
  pointer-events: all;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #2e7d32;
  border: none;
  appearance: none;
  margin-top: -7px; /* центрируем на 6px треке */
}

.CustomRangeSlider_thumb__Z0e5T::-webkit-slider-runnable-track {
  height: 6px;
  background: transparent;
}


.CustomRangeSlider_thumb__Z0e5T::-moz-range-thumb {
  pointer-events: all;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #2e7d32;
  border: none;
}

.CustomRangeSlider_inputs__ax471 {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.CustomRangeSlider_priceInput__AFIZm {
  flex: 1 1;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/CustomRangeSlider.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,MAAM;EACN,mBAAmB;EACnB,0CAA0C;EAC1C,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB,EAAE,4BAA4B;AAChD;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;;AAGA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".wrapper {\n  margin-top: 15px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.sliderTrack {\n  position: relative;\n  height: 30px;\n  background: #dcdcdc;\n  border-radius: 6px;\n  margin-bottom: 8px;\n}\n\n/* зелёная заливка */\n.sliderTrack {\n  position: relative;\n  height: 6px;\n  background: #e0e0e0;\n  border-radius: 3px;\n  margin-bottom: 8px;\n}\n\n/* Зелёная активная часть */\n.sliderTrack::before {\n  content: '';\n  position: absolute;\n  height: 6px;\n  background-color: #2e7d32;\n  border-radius: 3px;\n  top: 0;\n  left: var(--minPos);\n  width: calc(var(--maxPos) - var(--minPos));\n  z-index: 1;\n}\n\n.thumb {\n  pointer-events: none;\n  position: absolute;\n  top: -12px;\n  height: 30px;\n  width: 100%;\n  background: none;\n  appearance: none;\n  margin: 0;\n  z-index: 2;\n}\n\n.thumb::-webkit-slider-thumb {\n  pointer-events: all;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background-color: #2e7d32;\n  border: none;\n  appearance: none;\n  margin-top: -7px; /* центрируем на 6px треке */\n}\n\n.thumb::-webkit-slider-runnable-track {\n  height: 6px;\n  background: transparent;\n}\n\n\n.thumb::-moz-range-thumb {\n  pointer-events: all;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background-color: #2e7d32;\n  border: none;\n}\n\n.inputs {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.priceInput {\n  flex: 1;\n  padding: 8px 12px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `CustomRangeSlider_wrapper__GBwuM`,
	"sliderTrack": `CustomRangeSlider_sliderTrack__h1XCR`,
	"thumb": `CustomRangeSlider_thumb__Z0e5T`,
	"inputs": `CustomRangeSlider_inputs__ax471`,
	"priceInput": `CustomRangeSlider_priceInput__AFIZm`
};
export default ___CSS_LOADER_EXPORT___;
